// Step 10 — fetch wrapper for GET /api/progress.

import { progressResponseSchema, type ProgressResponse } from '@skena/schema'

interface ApiSuccess<T> {
  data: T
}
interface ApiError {
  error: { code: string; message: string }
}
type ApiResult<T> = ApiSuccess<T> | ApiError

export class ProgressApiError extends Error {
  constructor(
    public readonly code: string,
    message: string,
    public readonly status: number,
  ) {
    super(message)
  }
}

export async function fetchProgress(): Promise<ProgressResponse> {
  const res = await fetch('/api/progress', { credentials: 'same-origin' })
  const json = (await res.json().catch(() => ({}))) as ApiResult<unknown>
  if (!res.ok || 'error' in json) {
    const err = 'error' in json ? json.error : { code: 'INTERNAL', message: 'unexpected' }
    throw new ProgressApiError(err.code, err.message, res.status)
  }
  return progressResponseSchema.parse(json.data)
}

export const PROGRESS_QUERY_KEY = ['progress'] as const
